import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import { Helmet } from 'react-helmet'
import LinkButton from '../components/LinkButton'
import { useStaticQuery } from 'gatsby'

const Layout = ({ children }) => {
  const data = useStaticQuery(query)

  return (
    <>
      <Helmet title={data.site.siteMetadata.title}>
        <title>all the greens</title>
        <meta name="description" content={data.site.siteMetadata.title} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@not_nabeel" />
        <meta name="twitter:title" content="all the greens" />
        <meta name="twitter:description" content={data.site.siteMetadata.title} />
        <meta name="og:title" content="all the greens" />
        <meta name="og:description" content={data.site.siteMetadata.title} />
      </Helmet>
      <div className="lg:flex lg:flex-row lg:h-screen lowercase bg-black text-theme-black bg-pattern">
        <nav className="w-full flex-shrink-0 p-4 pt-8 bg-black lg:w-1/4">
          <div className="p-4 lg:p-8 lg:border-4 border-theme bg-secondary">
            <h2 className="p-2 text-4xl font-display text-theme-white line-wavy">
              All the Greens
            </h2>
            <LinkButton to="/" fullWidth>
              All the Plantsss
            </LinkButton>
          </div>
        </nav>

        <div className="p-4 lg:p-8 flex-grow-0 font-body overflow-y-auto w-full">
          <main className="p-4 pb-16 bg-theme-white border-4 border-theme-light">
            <MDXProvider
              components={{
                p: (props) => <p {...props} className="mt-8" />,
                h1: (props) => (
                  <h1 {...props} className="mt-8 line-wavy text-center text-2xl" />
                ),
                h2: (props) => (
                  <h2 {...props} className="mt-8 line-wavy text-center text-xl" />
                ),
                h3: (props) => (
                  <h3 {...props} className="mt-8 line-wavy text-center text-lg" />
                ),
                strong: (props) => <strong {...props} className="font-bold" />,
                a: (props) => <LinkButton {...props} to={props?.href} />,
                ul: (props) => (
                  <ul {...props} className="mt-8 list-inside list-square" />
                ),
                ol: (props) => (
                  <ul {...props} className="mt-8 list-inside list-square" />
                ),
                blockquote: (props) => (
                  <blockquote
                    {...props}
                    className="mdx-blockquote mt-8 px-2 py-1 border-4 border-theme"
                  />
                ),
              }}
            >
              {children}
            </MDXProvider>
          </main>
        </div>
      </div>
    </>
  )
}

export default Layout

const query = graphql`
  query SiteMeta {
    site {
      siteMetadata {
        title
      }
    }
  }
`
